import { useTranslation } from 'react-i18next';

import { IntentionBox } from './IntentionBox';

export function IntentionMapping() {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Personalization.components.SimilarProducts.components.IntentionMapping',
  });
  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-5 md:w-1/2">
      <h3 className="mb-3 text-lg font-semibold">{t('title')}</h3>

      <div className="space-y-4">
        <IntentionBox
          title={t('intentionBox.categoryElements.title')}
          items={t('intentionBox.categoryElements.items', {
            returnObjects: true,
          })}
        />

        <IntentionBox
          title={t('intentionBox.patternInsights.title')}
          items={t('intentionBox.patternInsights.items', {
            returnObjects: true,
          })}
        />

        <IntentionBox
          title={t('intentionBox.stylingIntent.title')}
          items={t('intentionBox.stylingIntent.items', {
            returnObjects: true,
          })}
        />
      </div>
    </div>
  );
}
